

















































import Vue from 'vue';
import { WebAuth } from '@/web';

import OptionWidget from '@/vue-components/util/OptionWidget.vue';
import { DefaultPhotos } from 'sparkello-core';

export default Vue.extend({
  name: 'AccountOptions',
  components: { OptionWidget },
  data() {
    return {};
  },
  computed: {
    title(): string {
      return 'Sparkello - Profile';
    },
    currentUser() {
      return this.$store.state.currentUser;
    },
    displayPhoto() {
      return this.$store.state.currentUser?.photoURL ? this.$store.state.currentUser?.photoURL  : DefaultPhotos.getDefaultProfilePhotoForName(this.$data?.currentUser?.displayName);
    },
  },
  methods: {
    logout() {
      console.log('Logout');
      const auth = WebAuth.getInstance();
      console.log(auth);

      auth.logout().then(() => {
        console.log('Logout');
        this.$store.dispatch('logout');
        this.$router.push('/');
      })
        .catch(err => {
          console.log(err);
        });
    },
  },
});
